var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/OnsiteMessage.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import convertOnsiteMessageData from './components/internal/convertOnsiteMessageData';
import { EmptyOnsiteMessage } from './components/internal/OnsiteMessageEventingHooks/EmptyOnsiteMessage';
import { EMPTY_ONSITE_MESSAGE_WRAPPER } from './components/internal/constants';
import { OnsiteMessageThemeWrapper } from './components/internal/OnsiteMessageThemeWrapper/OnsiteMessageThemeWrapper';
export var OnsiteMessage = function OnsiteMessage(_ref) {
  var messageData = _ref.messageData,
      placementName = _ref.placementName,
      additionalProps = _ref.additionalProps,
      additionalClickStreamData = _ref.additionalClickStreamData,
      supportedComponents = _ref.supportedComponents,
      triggerLocation = _ref.triggerLocation,
      triggerObject = _ref.triggerObject,
      triggerSource = _ref.triggerSource,
      Head = _ref.Head,
      clickHandler = _ref.clickHandler;
  var messageRenderingDetails = useMemo(function () {
    return convertOnsiteMessageData(messageData, placementName, additionalProps, triggerLocation, triggerObject, triggerSource);
  }, [messageData, placementName, additionalProps, triggerLocation, triggerObject, triggerSource]);
  /*
  In our `convertOnsiteMessageData` func, if `component` is undefined
  then `componentName` will be `EmptyOnsiteMessage`
  */

  if (!messageRenderingDetails) {
    return null;
  }

  var componentName = messageRenderingDetails.componentName,
      renderingProps = messageRenderingDetails.renderingProps;
  renderingProps.additionalClickStreamData = additionalClickStreamData;

  if (componentName === EMPTY_ONSITE_MESSAGE_WRAPPER) {
    return /*#__PURE__*/React.createElement(EmptyOnsiteMessage, _extends({}, renderingProps, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 42,
        columnNumber: 16
      }
    }));
  }

  var ComponentToRender = Object.prototype.hasOwnProperty.call(supportedComponents, componentName) && supportedComponents[componentName];

  if (ComponentToRender) {
    var _renderingProps$newLa;

    return /*#__PURE__*/React.createElement(OnsiteMessageThemeWrapper, {
      theme: renderingProps.theme,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 50,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement("div", {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 51,
        columnNumber: 17
      }
    }, // eslint-disable-next-line
    ((_renderingProps$newLa = renderingProps.newLaneEventData) === null || _renderingProps$newLa === void 0 ? void 0 : _renderingProps$newLa.should_display_ind) ? /*#__PURE__*/React.createElement(ComponentToRender, _extends({}, renderingProps, {
      Head: Head,
      clickHandler: clickHandler,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 55,
        columnNumber: 29
      }
    })) : /*#__PURE__*/React.createElement(EmptyOnsiteMessage, _extends({}, renderingProps, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 61,
        columnNumber: 29
      }
    }))));
  }

  return null;
};
OnsiteMessage.propTypes = process.env.NODE_ENV !== "production" ? {
  messageData: PropTypes.shape({
    eventId: PropTypes.string,
    decisionContext: PropTypes.string,
    messages: PropTypes.arrayOf(PropTypes.shape({
      skipDisplayReason: PropTypes.string,
      shouldDisplay: PropTypes.bool,
      isGlobalHoldout: PropTypes.bool,
      isPlacementHoldout: PropTypes.bool,
      placementName: PropTypes.string,
      testPhase: PropTypes.string,
      bucket: PropTypes.string,
      placementId: PropTypes.number,
      passThrottle: PropTypes.bool,
      lastModified: PropTypes.string,
      decisionContext: PropTypes.object,
      eventId: PropTypes.string,
      selectedTreatment: PropTypes.shape({
        component: PropTypes.string,
        id: PropTypes.number,
        lastModified: PropTypes.string,
        name: PropTypes.string,
        renderingProps: PropTypes.string,
        status: PropTypes.string
      }),
      qualifiedTreatments: PropTypes.arrayOf(PropTypes.shape({
        component: PropTypes.string,
        id: PropTypes.number,
        lastModified: PropTypes.string,
        name: PropTypes.string,
        renderingProps: PropTypes.string,
        status: PropTypes.string
      }))
    }))
  }),
  placementName: PropTypes.string,
  additionalProps: PropTypes.shape({
    signalForTriggerTracking: PropTypes.bool
  }),
  // eslint-disable-next-line zillow/react/forbid-prop-types
  additionalClickStreamData: PropTypes.object,

  /*
      Sample illustration of use:
      import { UpsellWrapper } from '@zillow/zrs-cms-messaging/lib/components/UpsellWrapper';
      import { ZOUpsellWrapper } from '@zillow/zrs-cms-messaging/lib/components/ZOUpsellWrapper';
      const components = {
          ZOUpsellWrapper,
          UpsellWrapper,
      };
      return (
          <OnsiteMessage
              messageData={messageData}
              placementName={placementName}
              supportedComponents={components}
          />
      );
  */
  supportedComponents: PropTypes.objectOf(PropTypes.elementType),
  triggerLocation: PropTypes.string,
  triggerObject: PropTypes.string,
  triggerSource: PropTypes.string,
  Head: PropTypes.func,
  clickHandler: PropTypes.func
} : {};
OnsiteMessage.defaultProps = {
  additionalClickStreamData: {},
  messageData: {},
  placementName: '',
  additionalProps: {},
  supportedComponents: {},
  triggerLocation: '',
  triggerObject: '',
  triggerSource: '',
  Head: undefined,
  clickHandler: function clickHandler() {}
};